<template>

  <!-- The landing page is displayed if the user is logged off, or the server health check fails. If the user is logged in 
       OR the global debug flag is set to TRUE, the landing page will not display, and the router view will be displayed instead. 
       If the landing page is displayed, the side menu will NOT be displayed.    
       
       To bypass the inconvenience of logging in as a developer, set the global debug flag to TRUE. 
       Or, login as usual and ensure the backend project is running (to recieve a succesful health check and login check)
  -->

  <AppHeader :nav-height="navHeightCSS"></AppHeader>

  <div class="mainContainer">

    <!-- SIDEBAR HIDDEN IF LANDING PAGE IS DISPLAYED -->

    <div id="SidebarDivID" 
         :class="{ sidebarSmall: 
         sidebarCollapsedComputed, 
         sidebarBig: !sidebarCollapsedComputed }" 
         v-if="!displayLandingPage">

      <AppSidebar :MenuIcon="menuIcon" @ToggleSidebar="HostToggleSidebar"></AppSidebar>

    </div>

    <div id="ContentDivID" 
         :class="{ contentDivBig: sidebarCollapsedComputed, contentDivSmall: !sidebarCollapsedComputed }">
      
      <!-- IF THE LANDING PAGE IS DISPLAYED, DO NOT DISPLAY THE ROUTER VIEW -->

      <LandingPage v-if="displayLandingPage"></LandingPage>

      <router-view v-else @RoleUpdate="HandleRoleUpdate" @MenuIconUpdate="HandleMenuIconUpdate"   />

    </div>
  </div>

  <!-- HelpDesk + link for CAAMS - may need to adjust placement and link -->


  <!-- <a href='#'
    @click="OpenHelpdesk" style="position: fixed; top: 100px; right: 0px; z-index: 999999;" title='CAAMSNG Helpdesk & Feedback'><img
      src="../public/vhd.png" alt="Helpdesk & Feedback" /></a> -->

  <!-- <a href='#'
    onclick="window.open('https://www.jccs.gov/HDPlus/Ext/App?Name=CAAMSNG', '_blank', 'resizable=no,scrollbars=yes,status=no,width=800, height=750');"
    style='position: fixed; top: 100px; right: 0px; z-index: 999999;' title='CAAMSNG Helpdesk & Feedback'><img
      src="../public/vhd.png" alt="Helpdesk & Feedback" /></a> -->


  <AppFooter></AppFooter>

</template>

<script>
import AppHeader from "./components/appLayout/AppHeader.vue";
import AppSidebar from "./components/appLayout/AppSidebar.vue";
import AppFooter from "./components/appLayout/AppFooter.vue";
import { store } from "@/store/store.js";
import LandingPage from "@/views/Home/LandingPage.vue";

export default {
  name: "App",
  data() {
    return {
      menuIcon: 'plus',
      sidebarCollapsed: false,
      usersRole: 'vendor',
      sidebaricon: 'plus',
      sidebarSizeCSS: '250px',
      sidebarSmallSizeCSS: '30px',
      /* Used to set the AppHeader CSS Height attribute AND the main container's top margin (so it's always exactly under the AppHeader element) */
      navHeightCSS: '50px',
      store,
    };
  },
  computed:{
    //these computed values kind of chain to add simplicity to the boolean checks in the layout
    debugging(){
      //if there is a debugging store value, set it here
      if(this.store.globalDebugging != null){
        return this.store.globalDebugging; 
      }
      //or assume you're not debugging
      return false;
    },
    healthyYN(){
      //if the global debugging flag is set to true, assume the server is 'healthy'
      if(this.debugging){
        return true; 
      }
      //if not debugging, get the health check from the store if it is not null
      else if(this.store.healthStatus != null){
        return this.store.healthStatus.healthyYN; 
      }
      //or assume healthy is false
      return false;
    },
    loggedInYN(){
      //if you're debugging, behave as if you're logged in
      if(this.debugging){
        return true; 
      }
      //if you're not debugging, get the value from the store
      else if(this.store.loggedIn != null){
        return this.store.loggedIn; 
      }

      //if no store value, assume you're not logged in
      return false;
    },
    displayLandingPage(){
      //similar to the above check, but defaults to false if the checks aren't met
      if(this.healthyYN == false || this.loggedInYN == false){
        return true; 
      }
      return false;
    },
    sidebarCollapsedComputed(){
      //if the landing page is displayed, the side bar menu is collapsed
      if(this.displayLandingPage){
        return true; 
      }

      //if not hiding due to one of the above reasosn, show or hide based on data value
      return this.sidebarCollapsed;
    },
  },
  components: { AppHeader, AppSidebar, AppFooter, LandingPage },
  methods: {
    HostToggleSidebar() {
      // console.log("App.vue: HostToggleSidebar()");
      this.$data.sidebarCollapsed = !this.$data.sidebarCollapsed;
    },

    HandleRoleUpdate(selectedRole) {
      // console.log('App.vue: selectedRole = ', selectedRole);
      this.$data.usersRole = selectedRole;
    },
    
    HandleMenuIconUpdate(selectedIcon) {
      this.$data.menuIcon = selectedIcon;
      // console.log('App.vue: selectedIcon = ', selectedIcon);
      // console.log('App.vue: this.$data.menuIcon = ', this.$data.menuIcon);
    },

    OpenHelpdesk(){
      window.open('https://www.jccs.gov/HDPlus/Ext/App?Name=CAAMSNG', '_blank', 'resizable=no,scrollbars=yes,status=no,width=800, height=750');
    }
  },
};
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 0px;
  /* This calculation takes the viewport width minus the difference in the viewport width and 100% width (this accounts for the vertical scrollbar's width) */
  width: calc(100vw - (100vw - 100%));
}

.mainContainer {
  margin: 0px;
  display: grid;
  grid-template-rows: auto;
  grid-template-columns: 100vw;
  /* This calculation takes the viewport width minus the difference in the viewport width and 100% width (this accounts for the vertical scrollbar's width) */
  width: calc(100vw - (100vw - 100%));
  margin-top: v-bind(navHeightCSS);
  display: flex;

}

.sidebarSmall {
  width: v-bind(sidebarSmallSizeCSS) !important;
}

.contentDivBig {
  /* This calculation takes the viewport width minus the difference in the viewport width and 100% width (this accounts for the vertical scrollbar's width) AND subtracts the sidebar's width when it is small */
  width: calc(100vw - v-bind(sidebarSmallSizeCSS) - (100vw - 100%)) !important;
  padding-left: 20px !important;
}

#ContentDivID {
  margin-top: 20px;
  margin-right: 0px;
  margin-bottom: 60px;
  padding: 0px 10px;
  /* This calculation takes the viewport width minus the difference in the viewport width and 100% width (this accounts for the vertical scrollbar's width) AND subtracts the sidebar's width when it is Expanded */
  width: calc(100vw - v-bind(sidebarSizeCSS) - (100vw - 100%));
}

#SidebarDivID {
  width: v-bind(sidebarSizeCSS);
}
</style>
